import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOrders } from "../repositories/storeRep";


const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getOrdersData = createAsyncThunk("orders", async (thunkAPI) => {
  const response = await getOrders();
  return response;
});
export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  extraReducers: {
    [getOrdersData.pending]: (state) => {
      state.loading = true;
    },
    [getOrdersData.fulfilled]: (state, action) => {
      state.loading = false;
      const data = [
        ["#14", "hussein","pending" ,"01/03/1996","$746.5"],
        ["#44" , "heba","rejected" , "04/03/1999","$906.5"],
        ["#555", "john","complete" , "01/03/2020","$76.5"],
        ["#444", "bruno","pending" , "01/08/2022","$7.5"],
        ["#334" , "ali","rejected" , "01/01/2021","$200.5"],
        ["#455", "adam","complete" , "01/03/1996","$746.20"],
        ["#555", "maya","pending" , "01/03/1996","$800.5"],
      ];
      state.data = data;
      //state.data= action.payload
    },
    [getOrdersData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default ordersSlice.reducer;
